import { useMemo } from "react";
import { AddableCourse, CourseLite, CourseSummary } from "../../types/course.response";
import { Requirement, Select } from "../../types/requirement.response";
import { getAllCourseOptionsForRequirement } from "../../utils/requirementResponseUtils";
import SidebarAddCourse from "./SidebarAddCourse";
import SidebarCourseSetSlots from "./SidebarCourseSetSlots";

interface SidebarOptionSlotsProps {
    rootNode: Select;
    requirement: Requirement;
    coursesMap: Record<string, CourseSummary>;
    onAdd: (course: AddableCourse, nodeId: string | null) => void | Promise<void>;
    onDelete: (course: CourseLite) => void | Promise<void>;
    isBroad?: boolean;
}

export default function SidebarOptionSlots({ rootNode, requirement, coursesMap, onAdd, onDelete, isBroad }: SidebarOptionSlotsProps) {
    const isFulfilled = rootNode.summary.isFulfilled;

    const allCourses = useMemo(
        () => getAllCourseOptionsForRequirement(requirement, coursesMap),
        [requirement, coursesMap]
    );

    return (
        <div className="mt-3 flex flex-col gap-4">
            {rootNode.children.map((child) => {
                if (child.type !== "COURSE_SET") return null;
                return (
                    <div key={child.id}>
                        {child.title && (
                            <div className="px-2 mb-1 text-xs font-semibold text-gray-400 uppercase tracking-wide">
                                {child.title}
                            </div>
                        )}
                        <div className="flex flex-col gap-0.5">
                            <SidebarCourseSetSlots
                                courseSet={child}
                                coursesMap={coursesMap}
                                requirementId={requirement.info.id}
                                onAdd={(course) => onAdd(course, child.id)}
                                onDelete={onDelete}
                                idPrefix="sidebar-option"
                                isBroad={isBroad}
                            />
                        </div>
                    </div>
                );
            })}
            {isFulfilled && (
                <SidebarAddCourse
                    allCourses={allCourses}
                    onAdd={(course) => onAdd(course, null)}
                    nodeId={null}
                    dropId={`sidebar-option-slot-${requirement.info.id}-extra`}
                    isBroad={isBroad}
                />
            )}
        </div>
    );
}
